<div class="row mt-2">
  <div class="col-md-5 mt-2">
    <h2>Approval Status:</h2>
    <p-select
      [appendTo]="'body'"
      [(ngModel)]="defaultInvoicePreviewStatus"
      (onChange)="onApprovalSelection($event)"
      [filter]="true"
      [showClear]="true"
      [options]="invoicePreviewStatus"
      optionLabel="name"
      optionValue="id">
    </p-select>
  </div>
  <div class="col-md-5 mt-2">
    <h2>Quick Note</h2>
    <textarea
      name=""
      id=""
      cols="30"
      rows="10"
      style="height: 90px; width: 100%"
      [(ngModel)]="quickQuote"
      class="form-control"></textarea>
  </div>
  <div class="col-md-2 mt-2">
    <p-button label="Submit" (click)="onSubmit()" />
  </div>
</div>
